/**
 * The writes this device made to a view and its object has not answered yet (docs/views.md#2-data), each kept under a
 * key of its own until the object answers it. A view's page and its sections' screens are pages of their own on the
 * same view, so a list kept whole by each would lose the others' writes: one page's answer would forget a write another
 * page still waits on.
 */
import type { Op } from "../shared/views/records";
import { forgetKept, keep, readKeptUnder } from "./device-store";

export interface KeptWrite {
  id: string;
  part: string;
  op: Op;
  /** When the write was made, and its place among the writes made in that millisecond on its page. */
  at: number;
  n: number;
}

const prefix = (view: string) => `outbox:${view}:`;

/** A view's unanswered writes, from every page on this device, in the order they were made. */
export async function keptWrites(view: string): Promise<KeptWrite[]> {
  const list = await readKeptUnder<KeptWrite>(prefix(view));
  return list.filter((write) => write?.id && write.op).sort((a, b) => a.at - b.at || a.n - b.n);
}
export const keepWrite = (view: string, write: KeptWrite) => keep(prefix(view) + write.id, write);
export const forgetWrite = (view: string, id: string) => forgetKept(prefix(view) + id);
